<app-page>
    <app-page-header title="Verlof">
        <mat-checkbox [formControl]="fcShowHistoric" after-title class="history-toggle">Toon historie</mat-checkbox>
        <a [routerLink]="['/', Routenames.leave, 'new']" actions mat-flat-button>
            <i class="fa-regular fa-plus"></i> Verlof toevoegen
        </a>
    </app-page-header>

    <div class="list-card">
        <app-data-list columns="170px minmax(0,1.3fr) 100px minmax(0,1.3fr) 160px 130px 72px" minWidth="970px">
            <div app-data-row header>
                <span>Soort</span>
                <span>Periode</span>
                <span>Tijden</span>
                <span>Opmerking</span>
                <span>Medewerker(s)</span>
                <span>Status</span>
                <span></span>
            </div>
            @for (item of items(); track item.key) {
                @if (item.head) {
                    <app-day-group>{{ item.head }}</app-day-group>
                } @else {
                    @let row = item.row;
                    @let leave = row.leave;
                    <a [class.past]="row.past"
                       [routerLink]="['/', Routenames.leave, leave.id]"
                       [tone]="row.running ? 'ok' : null"
                       app-data-row>
                        <span class="type">
                            <app-icon-tile [icon]="row.style.icon"
                                           [style.background]="row.style.bg"
                                           [style.color]="row.style.fg"
                                           class="type-tile"></app-icon-tile>
                            <span class="ui-cell">
                                <span class="ui-strong ui-ellipsis">{{ row.type?.name ?? leave.leave_type }}</span>
                                @if (row.running) {
                                    <span class="running">Loopt nu</span>
                                }
                            </span>
                        </span>
                        <span class="ui-cell">
                            <!-- More than one day: without the day names, so the period stays on one line -->
                            <span>
                                @if ((leave.begindate | isOtherDate : leave.enddate)) {
                                    @let beginYear = (leave.begindate | date :'yyyy');
                                    @let endYear = (leave.enddate | date :'yyyy');
                                    {{ leave.begindate | date :(beginYear !== endYear ? 'd MMM yyyy' : 'd MMM') }} t/m {{ leave.enddate | date :'d MMM yyyy' }}
                                } @else {
                                    {{ leave.begindate | date :'EEE d MMM yyyy' }}
                                }
                            </span>
                            <span class="ui-meta sub">
                                @if (row.repeat) {
                                    <i class="fa-regular fa-repeat"></i> {{ row.repeat }} ·
                                }
                                {{ row.summary }}
                            </span>
                        </span>
                        <span class="ui-mono times">{{ row.times }}</span>
                        <span class="ui-cell comments">
                            @if (leave.comment) {
                                <span class="comment" title="Opmerking (alleen voor jou en management)">
                                    <i class="fa-regular fa-lock"></i><span class="ui-ellipsis">{{ leave.comment }}</span>
                                </span>
                            }
                            @if (leave.public_comment) {
                                <span class="comment" title="Publieke opmerking (zichtbaar voor collega's)">
                                    <i class="fa-regular fa-globe"></i><span class="ui-ellipsis">{{ leave.public_comment }}</span>
                                </span>
                            }
                            @if (!leave.comment && !leave.public_comment) {
                                <span class="none">—</span>
                            }
                        </span>
                        <span class="people">
                            @if (leave.common) {
                                <i class="fa-regular fa-building ui-faint"></i>
                                <span>Bedrijfsbreed</span>
                            } @else if (leave.users?.length === 1) {
                                <app-avatar [name]="leave.users[0].name" [seed]="leave.users[0].id" size="xs"></app-avatar>
                                <span class="ui-ellipsis">{{ leave.users[0].name }}</span>
                            } @else if (leave.users?.length) {
                                <app-avatar-stack>
                                    @for (user of row.stackUsers; track user.id) {
                                        <app-avatar [name]="user.name" [seed]="user.id" size="xs"></app-avatar>
                                    }
                                </app-avatar-stack>
                                <span [title]="row.userNames" class="ui-ellipsis">{{ row.userNames }}</span>
                            }
                        </span>
                        <span class="ui-cell">
                            @if (leave.approved_at) {
                                <app-status-dot tone="ok">Goedgekeurd</app-status-dot>
                                <span class="ui-meta ui-faint status-sub">{{ leave.approved_at | codaltDate:'EEE d MMM' }}</span>
                            } @else {
                                <app-status-dot tone="warn">In afwachting</app-status-dot>
                            }
                        </span>
                        <span class="row-actions">
                            @if ((Roles.Management | hasRole) && !leave.approved_by && !leave.approved_at) {
                                <button (click)="$event.preventDefault(); approve($event, leave)" aria-label="Goedkeuren" class="approve" mat-icon-button
                                        matTooltip="Goedkeuren" type="button">
                                    <i class="fa-regular fa-check"></i>
                                </button>
                            }
                            @if ((Roles.Management | hasRole) || (now | datetimeBefore : leave.begindate)) {
                                <button (click)="$event.preventDefault(); delete($event, leave)" aria-label="Verwijderen" class="delete" mat-icon-button
                                        matTooltip="Verwijderen" type="button">
                                    <i class="fa-regular fa-trash-can"></i>
                                </button>
                            }
                        </span>
                    </a>
                }
            }
        </app-data-list>
        @if (leaves() === null) {
            <app-empty-state>Aan het laden...</app-empty-state>
        } @else if (!items().length) {
            <app-empty-state>{{ fcShowHistoric.value ? 'Geen verlof in de historie.' : 'Geen verlof gepland.' }}</app-empty-state>
        }
    </div>
    <span class="ui-meta ui-faint">Verwijderen kan zolang het verlof nog niet begonnen is.</span>
</app-page>
